var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isFolder
      ? _c(
          "div",
          {
            class: { bold: _vm.isFolder },
            on: {
              click: function($event) {
                return _vm.toggleFolder()
              }
            }
          },
          [
            _vm._t(
              "folder-description",
              [
                _vm._v(" " + _vm._s(_vm.item.name) + " "),
                _c("span", [_vm._v("[" + _vm._s(_vm.isOpen ? "-" : "+") + "]")])
              ],
              { item: _vm.item, isOpen: _vm.isOpen }
            )
          ],
          2
        )
      : _vm._e(),
    !_vm.isFolder
      ? _c(
          "div",
          { on: { click: _vm.selectItem } },
          [
            _vm._t(
              "item-description",
              [_vm._v(" " + _vm._s(_vm.item.name) + " ")],
              { item: _vm.item }
            )
          ],
          2
        )
      : _vm._e(),
    _vm.isFolder
      ? _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isOpen,
                expression: "isOpen"
              }
            ],
            staticClass: "level"
          },
          _vm._l(_vm.item.children, function(child, index) {
            return _c("tree-item", {
              key: child.id || child.optionId || index,
              staticClass: "item",
              attrs: { item: child },
              on: {
                "open-folder": function($event) {
                  return _vm.$emit("open-folder", $event)
                },
                "add-item": function($event) {
                  return _vm.$emit("add-item", $event)
                },
                "select-item": function($event) {
                  return _vm.$emit("select-item", $event)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "folder-description",
                    fn: function(ref) {
                      var item = ref.item
                      var isOpen = ref.isOpen
                      return [
                        _vm._t(
                          "folder-description",
                          [
                            _vm._v(" " + _vm._s(item.name) + " "),
                            _c("span", [
                              _vm._v("[" + _vm._s(isOpen ? "-" : "+") + "]")
                            ])
                          ],
                          { item: item, isOpen: isOpen }
                        )
                      ]
                    }
                  },
                  {
                    key: "item-description",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._t(
                          "item-description",
                          [_vm._v(" " + _vm._s(item.name) + " ")],
                          { item: item }
                        )
                      ]
                    }
                  }
                ],
                null,
                true
              )
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }